export default "__VITE_ASSET__DiIqmO18__"